import { isArray } from "underscore";
import System from "./system";
import Constants from "./Constants";

const { avUserInfoData } = System

class RoleAndPermission {

    static catalogPermission = {
        catalog: 'catalog'
    }

    static inventoryPermission = {
        inventory: 'inventory',
        // excess_inventory: 'excess_inventory'
    }

    static pricingPermission = {
        web_pricing: 'web_pricing',
        customer_pricing: 'customer_pricing',
        // promotional_pricing: 'promotional_pricing'
    }

    static accountPermission = {
        account_list: 'account_list'
    }

    static productPermission = {
        product_detail: 'product_detail',
        product_listing: 'product_listing',
        product_compare: 'product_compare',
        add_to_bom: 'add_to_bom',
        add_to_cart: 'add_to_cart',
        view_cart: 'view_cart'
    }

    static cartPermission = {
        backorder: 'backorder',
        scheduling: 'scheduling'
    }

    static checkoutPermission = {
        checkout: 'checkout',
        export_compliance: 'export_compliance',
        place_order: 'place_order'
    }

    static toolsPermission = {
        order: 'order',
        bom: 'bom',
    }

    static profilePermission = {
        add_edit_address: 'add_edit_address',
        submit_req_for_address: 'submit_req_for_address',
        req_to_join_existing_acc: 'req_to_join_existing_acc',
        // req_new_terms_acc: 'req_new_terms_acc',
        req_web_acc_registration: 'req_web_acc_registration',
        edit_profile_details: 'edit_profile_details',
        my_contact: 'my_contact',
    }

    static adminPermission = {
        user_admin: 'user_admin',
        account_admin: 'account_admin',
        bom_admin: 'bom_admin',
        export_compliance_admin: 'export_compliance_admin',
        // order_admin: 'order_admin'
    }

    static roles = {
        ZV: "ZV",
        ZC: "ZC",
        ZA: "ZA",
        PE: "PE",
        VE: "VE",
        "VE(PE)": "VE(PE)",

        ZB: "ZB", // External
        ZX: "ZX", // External
        APACGUEST: "APACGUEST",
        APACWEB: "APACWEB",
        JAPANGUEST: "JAPANGUEST",
        JAPANWEB: "JAPANWEB",
        AVNETINTERNAL: "AVNETINTERNAL",
        ISADMIN: 'ISADMIN'
    }

    static getPermissionByRole = (roleType) => {
        let activePermissions = {}

        if (roleType === this.roles.ZV) {
            activePermissions = {
                ...this.catalogPermission,
                ...this.inventoryPermission,
                ...this.productPermission,
                ...this.cartPermission,
                ...this.toolsPermission,
                ...this.pricingPermission,
                [this.checkoutPermission.checkout]: this.checkoutPermission.checkout,
                [this.profilePermission.my_contact]: this.profilePermission.my_contact,
                [this.adminPermission.bom_admin]: this.adminPermission.bom_admin,
                [this.adminPermission.export_compliance_admin]: this.adminPermission.export_compliance_admin,
            }
        } else if (roleType === this.roles.ZC) {
            activePermissions = {
                ...this.catalogPermission,
                ...this.inventoryPermission,
                ...this.productPermission,
                ...this.cartPermission,
                ...this.pricingPermission,
                [this.checkoutPermission.checkout]: this.checkoutPermission.checkout,
                [this.toolsPermission.bom]: this.toolsPermission.bom,
                [this.profilePermission.my_contact]: this.profilePermission.my_contact,
                [this.adminPermission.bom_admin]: this.adminPermission.bom_admin,
                [this.adminPermission.export_compliance_admin]: this.adminPermission.export_compliance_admin,
            }
        } else if (roleType === this.roles.ZA) {
            activePermissions = {
                ...this.catalogPermission,
                ...this.inventoryPermission,
                ...this.pricingPermission,
                ...this.productPermission,
                ...this.cartPermission,
                ...this.toolsPermission,
                [this.accountPermission.account_list]: this.accountPermission.account_list,
                [this.checkoutPermission.checkout]: this.checkoutPermission.checkout,
                [this.profilePermission.my_contact]: this.profilePermission.my_contact,
                [this.adminPermission.bom_admin]: this.adminPermission.bom_admin,
                [this.adminPermission.export_compliance_admin]: this.adminPermission.export_compliance_admin,
            }
        } else if (roleType === this.roles.PE || roleType === this.roles.VE || roleType === this.roles["VE(PE)"]) {
            activePermissions = {
                ...this.catalogPermission,
                ...this.inventoryPermission,
                ...this.productPermission,
                ...this.cartPermission,
                ...this.toolsPermission,
                ...this.pricingPermission,
                [this.checkoutPermission.checkout]: this.checkoutPermission.checkout,
                [this.profilePermission.my_contact]: this.profilePermission.my_contact,
                [this.adminPermission.bom_admin]: this.adminPermission.bom_admin,
                [this.adminPermission.export_compliance_admin]: this.adminPermission.export_compliance_admin,
            }
        } else if (roleType === this.roles.ZB || roleType === this.roles.ZX) {
            activePermissions = {
                ...this.catalogPermission,
                ...this.inventoryPermission,
                ...this.pricingPermission,
                ...this.productPermission,
                ...this.cartPermission,
                ...this.toolsPermission,
                [this.accountPermission.account_list]: this.accountPermission.account_list,
                [this.checkoutPermission.checkout]: this.checkoutPermission.checkout,
                [this.checkoutPermission.place_order]: this.checkoutPermission.place_order,
                [this.profilePermission.submit_req_for_address]: this.profilePermission.submit_req_for_address,
                [this.profilePermission.req_to_join_existing_acc]: this.profilePermission.req_to_join_existing_acc,
                [this.profilePermission.edit_profile_details]: this.profilePermission.edit_profile_details,
                [this.profilePermission.my_contact]: this.profilePermission.my_contact,
            }
        } else if (roleType === this.roles.APACGUEST || roleType === this.roles.JAPANGUEST) {
            activePermissions = {
                ...this.catalogPermission,
                ...this.inventoryPermission,
                ...this.productPermission,
                [this.pricingPermission.web_pricing]: this.pricingPermission.web_pricing,
                [this.toolsPermission.bom]: this.toolsPermission.bom,
                [this.profilePermission.req_web_acc_registration]: this.profilePermission.req_web_acc_registration,
            }
        } else if (roleType === this.roles.APACWEB) {
            activePermissions = {
                ...this.catalogPermission,
                ...this.inventoryPermission,
                ...this.productPermission,
                ...this.toolsPermission,
                [this.pricingPermission.web_pricing]: this.pricingPermission.web_pricing,
                [this.checkoutPermission.checkout]: this.checkoutPermission.checkout,
                [this.checkoutPermission.place_order]: this.checkoutPermission.place_order,
                [this.profilePermission.add_edit_address]: this.profilePermission.add_edit_address,
                [this.profilePermission.edit_profile_details]: this.profilePermission.edit_profile_details,
                [this.profilePermission.my_contact]: this.profilePermission.my_contact,
            }
        } else if (roleType === this.roles.AVNETINTERNAL) {
            activePermissions = {
                ...this.catalogPermission,
                ...this.inventoryPermission,
                ...this.productPermission,
                ...this.cartPermission,
                [this.pricingPermission.web_pricing]: this.pricingPermission.web_pricing,
                [this.toolsPermission.bom]: this.toolsPermission.bom,
                [this.adminPermission.bom_admin]: this.adminPermission.bom_admin,
                [this.adminPermission.export_compliance_admin]: this.adminPermission.export_compliance_admin,
            }
        }
        else if (roleType === this.roles.JAPANWEB) {
            activePermissions = {
                ...this.catalogPermission,
                ...this.productPermission,
                ...this.checkoutPermission,
                ...this.toolsPermission,
                [this.inventoryPermission.inventory]: this.inventoryPermission.inventory,
                [this.pricingPermission.web_pricing]: this.pricingPermission.web_pricing,
                [this.cartPermission.backorder]: this.cartPermission.backorder,
                [this.profilePermission.add_edit_address]: this.profilePermission.add_edit_address,
                [this.profilePermission.edit_profile_details]: this.profilePermission.edit_profile_details,
                [this.profilePermission.my_contact]: this.profilePermission.my_contact,
            }
        }
        else if (roleType === this.roles.ISADMIN) {
            activePermissions = {
                ...this.catalogPermission,
                ...this.productPermission,
                [this.pricingPermission.web_pricing]: this.pricingPermission.web_pricing,
                [this.adminPermission.user_admin]: this.adminPermission.user_admin,
                [this.adminPermission.account_admin]: this.adminPermission.account_admin,
                [this.toolsPermission.bom]: this.toolsPermission.bom,
                [this.adminPermission.export_compliance_admin]: this.adminPermission.export_compliance_admin,
                [this.inventoryPermission.inventory]: this.inventoryPermission.inventory,
            }
        }
        return activePermissions
    }

    static loadPermissionBasedOnAuthRole() {
        const r = avUserInfoData?.email ? avUserInfoData?.roles?.length ? avUserInfoData.roles : [] : [];
        const p = [];
        let speedBoat = System.avUserInfoData.speedBoatAbbr
        let userType = System.avUserInfoData.currentUser
        let activePermissions = {}

        const setActivePermission = () => {
            if (activePermissions && Object.entries(activePermissions).length > 0) {
                Object.entries(activePermissions).map((v_inner) => {
                    p.push(v_inner[0])
                })
            }
        }

        if (System.avUserInfoData.isAdmin) { // Avnet Admin User
            activePermissions = this.getPermissionByRole(this.roles.ISADMIN)
            setActivePermission()
        }

        if (System.validateDomain(System.avUserInfoData.email)) { // Avnet Internal User
            activePermissions = this.getPermissionByRole(this.roles.AVNETINTERNAL)
            setActivePermission()
        }

        if (r && isArray(r) && r.length > 0) { // APAC core user
            r.map((v) => {
                activePermissions = this.getPermissionByRole(v)
                setActivePermission()
            })
        } else if (speedBoat === Constants.speedBoats.apacAbbr && userType === Constants.siteUser.WEB && !System.validateDomain(System.avUserInfoData.email)) { // APAC External web user
            activePermissions = this.getPermissionByRole(this.roles.APACWEB)
            setActivePermission()
        } else if (speedBoat === Constants.speedBoats.japanAbbr && userType === Constants.siteUser.WEB && !System.validateDomain(System.avUserInfoData.email)) { // JAPAN External web user
            activePermissions = this.getPermissionByRole(this.roles.JAPANWEB)
            setActivePermission()
        } else if (speedBoat === Constants.speedBoats.apacAbbr && userType === Constants.siteUser.GUEST) { // APAC guest user
            activePermissions = this.getPermissionByRole(this.roles.APACGUEST)
            setActivePermission()
        } else if (speedBoat === Constants.speedBoats.japanAbbr && userType === Constants.siteUser.GUEST) { // JAPAN guest user
            activePermissions = this.getPermissionByRole(this.roles.JAPANGUEST)
            setActivePermission()
        }

        window.active_permissions = p;
        return p;
    }

    static checkActivePermission(slug) {
        if (window.active_permissions.includes(slug)) {
            return true;
        }
        return false;
    }
}

export default RoleAndPermission;